/* vitals-high 0829: flush jQuery-ready callbacks queued by the head shim.
   Loaded with defer AFTER jquery.js/apps.js/theme.js so all plugins exist. */
(function () {
  var q = (window.__jqq && window.__jqq.slice) ? window.__jqq.slice() : [];
  window.__jqq = { push: function (f) { window.jQuery(f); } };
  for (var i = 0; i < q.length; i++) {
    try { window.jQuery(q[i]); } catch (e) { if (window.console) console.error('vitals-flush:', e); }
  }
})();
